import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'

import { VueEditor } from 'vue2-editor'

export default {
  name: 'TermsOfUse',
  data,
  methods,
  mounted,
  components: {
    VueEditor,
  },
}
